/*
*@Author: dcl
*@Description: 公示栏页面
*@Date: 2022-11-15 16:31:59
*/
<template>
<div class="ibo-box">
    <div class="box-con" v-for="(item, index) in newsList" :key="index + 'newsList'">
        <div class="con-right">
            <div class="right-pot" v-if="index>1 && index<newsList.length && (item.time.split('-')[0] + item.time.split('-')[1]) == (newsList[index - 1].time.split('-')[0] + newsList[index - 1].time.split('-')[1])">
                <el-image :src="pot" />
            </div>
            <div class="right-txt" v-else>
                {{ item.time.split('-')[0] + '-' + item.time.split('-')[1] }}
            </div>
            <div class="right-line"></div>
        </div>
        <div class="con-middle"></div>
        <div class="con-left">
            <div class="con-time">{{ item.time }}</div>
            <div class="con-txt" :title="item.txt">
                <a :href="`/static/pdf/${item.txt}.pdf`" target="_blank" rel="noopener noreferrer">{{ item.txt }}</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            pot: require('../../assets/board_pot.png'),
            newsList: this.$store.state.newsList
        }
    },
    // created() {
    //     this.newsList = this.$store.state.newsList
    //     this.newsList.map((item) => {

    //     })
    // }
}
</script>

<style lang="less" scoped>
::-webkit-scrollbar-track-piece {
    //滚动条凹槽的颜色，还可以设置边框属性
    background-color: #f8f8f8;
}

::-webkit-scrollbar {
    //滚动条的宽度
    width: 9px;
    height: 9px;
}

::-webkit-scrollbar-thumb {
    //滚动条的设置
    background-color: #dddddd;
    background-clip: padding-box;
    min-height: 28px;
}

::-webkit-scrollbar-thumb:hover {
    background-color: #bbb;
}

.ibo-box {
    height: 370px;
    overflow-y: auto;
    font-size: 0.53rem;

    .box-con {
        display: flex;
        flex-direction: row;

        .con-right {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            width: 3.47rem;

            .right-txt {
                padding: .13rem .53rem .1rem;
                color: 0.6rem;
                text-align: center;
                color: #FFFFFF;
                background-color: #FF9600;
            }

            .right-pot {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 1.07rem;
            }

            .right-line {
                margin: .2rem 0;
                height: calc(100% - .2rem);
                width: 0;
                border: 0.03rem dashed #FF9600;
            }
        }

        .con-middle {
            height: 0.03rem;
            width: 0.9rem;
            background-color: #FF9600;
            margin: .47rem .3rem 0 .33rem;
        }

        .con-left {
            padding: .5rem .63rem 0;
            color: 0.53rem;
            background-color: #FAFAFA;
            width: 35.41rem;
            margin-bottom: 1.47rem;

            .con-time {
                font-weight: bold;
                color: #FF0000;
            }

            .con-txt {
                cursor: pointer;
                // white-space: nowrap;
                // overflow: hidden;
                // text-overflow: ellipsis;
                padding: .27rem 0 1.03rem;

                a {
                    text-decoration: none;
                    color: #2c3e50;
                }

                a:hover {
                    color: #0476c3;
                }
            }
        }
    }

    .box-con:first-child {
        margin-top: 1.4rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Information/board.vue